
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bjglyzvjyxrhwgjarmuu.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJqZ2x5enZqeXhyaHdnamFybXV1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzUwOTc3NDAsImV4cCI6MjA5MDY3Mzc0MH0.QxmcHFWoJ975R3yroyof4lOG0cWEkCN2Hb2F7KPzJG4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
